module.exports = __webpack_public_path__ + "assets/zelcash.49826eea.png";